import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '../components/Button/Button'
import { Color, Direction } from '../utils/constants'
import Background from '../assets/backgrounds/technology-tailoring.svg'
import MovingBackground from './MovingBackground/MovingBackground'
import { Link } from '../utils/helpers'

interface InformationBlockProps {
  title: string
  description: string
  button?: string
  link: string
}

const InformationBlock = ({ title, description, button, link }: InformationBlockProps) => {
    return (
        <div className='bg-purple relative overflow-hidden'>
            <MovingBackground
                component={Background}
                classes={{ background: 'mix-blend-multiply' }}
                animate
            >
                <div className='side-padding-md 2xl:content-padding 3xl:max-w-screen-2xl mx-auto py-24 text-white grid md:grid-cols-2 items-center gap-x-24 relative z-10 text-center md:text-left'>
                    <div className='max-w-[330px] md:max-w-[610px] mx-auto '>
                        <FormattedMessage id={title} tagName='h2' />
                    </div>
                    <div className='flex flex-col items-center md:items-start justify-between py-5 max-w-[330px] md:max-w-[400px] mx-auto gap-y-5'>
                        <FormattedMessage id={description} />
                        <Link to={link}>
                            <Button buttonColor={Color.WHITE} chevron={Direction.RIGHT} outerClasses='w-max'>
                                <FormattedMessage id={button || 'button.learnMore'} tagName='h6' />
                            </Button>
                        </Link>
                    </div>
                </div>
            </MovingBackground>
        </div>
    )
}

export default InformationBlock
